import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Divider } from '@kambi/spark';

import classes from '../../../App.module.css';
import TestBlock from 'components/layout/test-block/TestBlock';
import Description from 'components/odds/description/Description';
import {
    FormatDecimalOdds,
    FormatOdds,
    GetAmericanOdds,
    GetFractionalOdds,
} from 'components/odds/jsonExamples';
import CodeBlock from 'components/layout/code-block/CodeBlock';
import { UtilsTypes } from 'constants/utilsTypes';
import OddsUtilsTabs from '../odds-tabs/OddsUtilsTabs';

const OddsHelperView = ({ type, title }) => {
    const navigate = useNavigate();

    return (
        <div className={classes.Wrapper}>
            <Button
                color="primary"
                variant="outlined"
                onClick={() => navigate('/odds')}
            >
                Back
            </Button>
            <div className={classes.Divider}>
                <Divider />
            </div>
            <div className={classes.Content}>
                <div className={classes.Title}>{title}</div>
                <div className={classes.Main}>
                    <Description type={type} />
                    <Divider />
                    {type === UtilsTypes.FORMAT_DECIMAL_ODDS && (
                        <CodeBlock
                            title={FormatDecimalOdds.title}
                            expectedOutput={FormatDecimalOdds.expectedOutput}
                            initialDisplayedCode={
                                FormatDecimalOdds.initialDisplayedCode
                            }
                            moreCode={FormatDecimalOdds.moreCode}
                        />
                    )}
                    {type === UtilsTypes.GET_AMERICAN_ODDS && (
                        <CodeBlock
                            title={GetAmericanOdds.title}
                            expectedOutput={GetAmericanOdds.expectedOutput}
                            initialDisplayedCode={
                                GetAmericanOdds.initialDisplayedCode
                            }
                            moreCode={GetAmericanOdds.moreCode}
                        />
                    )}
                    {type === UtilsTypes.GET_FRACTIONAL_ODDS && (
                        <CodeBlock
                            title={GetFractionalOdds.title}
                            expectedOutput={GetFractionalOdds.expectedOutput}
                            initialDisplayedCode={
                                GetFractionalOdds.initialDisplayedCode
                            }
                            moreCode={GetFractionalOdds.moreCode}
                        />
                    )}
                    {type === UtilsTypes.FORMAT_ODDS && (
                        <>
                            <CodeBlock
                                title={FormatOdds.title}
                                expectedOutput={FormatOdds.expectedOutput}
                                initialDisplayedCode={
                                    FormatOdds.initialDisplayedCode
                                }
                                moreCode={FormatOdds.moreCode}
                            />
                            <OddsUtilsTabs type={type} />
                        </>
                    )}
                    <TestBlock
                        title="You can test the odds utils functions by adding the input parameters as
                a JSON object in the below textarea, click Run and check the
                Output in the right"
                        type={type}
                    />
                </div>
            </div>
        </div>
    );
};

export default OddsHelperView;
